import Promise from 'bluebird';

import isOwnerEmpty from '../../lib/is-owner-empty';
import { post } from '../../lib/http-request';

export const SUBMIT_OWNERSHIP = 'SUBMIT_OWNERSHIP';
export const SUBMIT_OWNERSHIP_PROCESSING = 'SUBMIT_OWNERSHIP_PROCESSING';
export const SUBMIT_OWNERSHIP_COMPLETED = 'SUBMIT_OWNERSHIP_COMPLETED';
export const ADD_OWNER = 'ADD_OWNER';
export const UPDATE_OWNER = 'UPDATE_OWNER';
export const REMOVE_OWNER = 'REMOVE_OWNER';
export const BO_SIGNIFICANT_OWNER_FLAG = 'BO_SIGNIFICANT_OWNER_FLAG';
export const BO_SIGNIFICANT_OWNER_FLAG_PROCESSING = 'BO_SIGNIFICANT_OWNER_FLAG_PROCESSING';
export const BO_SIGNIFICANT_OWNER_FLAG_COMPLETED = 'BO_SIGNIFICANT_OWNER_FLAG_COMPLETED';
const PROCESSING_SUBMIT = 'PROCESSING_SUBMIT';
const SUBMIT_COMPLETED = 'SUBMIT_COMPLETED';

const submitOwners = (path, owners) => post(path, { owners, variation: 'ALT' });
const submitOwnershipFlagData = (path, data) => post(path, {...data, variation: 'ALT' });

export const addOwner = () => ({
  type: ADD_OWNER
});

export const updateOwner = (index, field, value, errors) => ({
  type: UPDATE_OWNER,
  errors,
  field,
  value,
  index
});

export const removeOwner = () => ({
  type: REMOVE_OWNER
});

export const hasIncompleteOwner = (state) => {
  return state.owners.find((owner) => {
    if (!isOwnerEmpty(owner)) {
      const { errors } = owner;
      return errors && Object.keys(errors).reduce((curr, key) => (!!errors[key] || curr), false);
    }
    return true;
  });
};

export const submitOwnershipInfo = (owners, hasIncompleteOwner, submitFn = submitOwners) => {
  return (dispatch) => {
    return new Promise((resolve, reject) => {
      if (owners && owners.length && !hasIncompleteOwner) {
        dispatch({
          type: PROCESSING_SUBMIT
        });

        dispatch({
          type: SUBMIT_OWNERSHIP,
          previousRoute: '/patientsolutions/enroll/ownership/add-owners'
        });

        return submitFn('/patientsolutions/enroll/ownership/add-owners', owners)
          .then((data) => {
            dispatch({
              type: SUBMIT_OWNERSHIP_COMPLETED,
              payload: data
            });
            resolve(data);
          })
          .catch(reject)
          .finally(() => {
            dispatch({
              type: SUBMIT_COMPLETED
            });
          });
      }

      dispatch({
        type: SUBMIT_OWNERSHIP,
        triggerValidations: true
      });
    });
  };
};

export const submitOwnershipFlag = (data, submitFn = submitOwnershipFlagData) => {

  return (dispatch) => {
    return new Promise((resolve, reject) => {
      dispatch({
        type: PROCESSING_SUBMIT
      });

      const { boSignificantOwnerFlag } = data;
      const action = {
        type: BO_SIGNIFICANT_OWNER_FLAG,
        value: boSignificantOwnerFlag
      };

      dispatch(action);

      submitFn('/patientsolutions/enroll/ownership', { boSignificantOwnerFlag })
        .then(resolve)
        .catch(reject)
        .finally(() => {
          dispatch({
            type: SUBMIT_COMPLETED
          });
        });
    });
  };
};

